import $ from 'jquery';
import Masonry from 'masonry-layout'; // https://www.npmjs.com/package/masonry-layout

// $(document).ready(function() {
//     var grid = $('.boites')[0]; // Convertit l'objet jQuery en élément DOM natif
//     // Vérifie si l'élément grid existe avant d'initialiser Masonry
//     if (grid) {
//         var msnry = new Masonry(grid, {
//             itemSelector: '.boite', // Sélecteur pour les éléments de grille individuels
//             columnWidth: '.paragraph.paragraph--type--boite', // Un élément de grille servant de référence pour la largeur de colonne
//             percentPosition: true, // Utilise des positions en pourcentage pour une réactivité accrue
//             gutter: 20 // Espace entre les éléments de la grille
//         });
//     }

//     function initMasonry() {
//         var grid = $('.article-list-item')[0]; 
//         if (grid) {
//             new Masonry(grid, {
//                 itemSelector: '.views-row',
//                 columnWidth: getColumnWidth(), 
//                 percentPosition: true,
//                 gutter: 16, 
//                 horizontalOrder: true
//             });
//             console.log(getColumnWidth())

//         }
//     }

//     function getColumnWidth() {
//         // Sur mobiles et tablettes, on prend la moitié de la largeur du parent
//         return window.innerWidth < 1024 ? $('.article-list-item').width() / 2 - 8 : 356;
//     }

//     initMasonry();

//     // Forcer Masonry à se recalculer après chaque redimensionnement
//     $(window).resize(function() {
//         $('.article-list-item').masonry('destroy'); // Détruit Masonry avant de le recréer
//         initMasonry();
//     });

// });




$(document).ready(function() {
    var grid = $('.boites')[0]; // Convertit l'objet jQuery en élément DOM natif
    // Vérifie si l'élément grid existe avant d'initialiser Masonry
    if (grid) {
        var msnry = new Masonry(grid, {
            itemSelector: '.boite', // Sélecteur pour les éléments de grille individuels
            columnWidth: '.paragraph.paragraph--type--boite', // Un élément de grille servant de référence pour la largeur de colonne
            percentPosition: true, // Utilise des positions en pourcentage pour une réactivité accrue
            gutter: 20 // Espace entre les éléments de la grille
        });
    }

    function initMasonry() {
        var grid = $('.article-list-item')[0]; 
        if (grid) {
            msnry = new Masonry(grid, {
                itemSelector: '.views-row',
                columnWidth: getColumnWidth(), 
                percentPosition: true,
                gutter: 16, 
                horizontalOrder: true
            });
        }
    }
    
    function getColumnWidth() {
        // Sur mobiles et tablettes, on prend la moitié de la largeur du parent
        if(window.innerWidth <= 480){
            console.log('mobile')
            return $('.article-list-item').width();
        }else if( 480 < window.innerWidth && window.innerWidth <= 1200){
            console.log('tablette')
            return $('.article-list-item').width() / 2 - 8;
        }else{
            return 356;
        }
        // return window.innerWidth <= 1200 ? $('.article-list-item').width() / 2 - 8 : 356;
    }

    initMasonry();

    // Forcer Masonry à se recalculer après chaque redimensionnement
    $(window).resize(function() {
        msnry.destroy()
        initMasonry();
    });

});
